import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { AppsSharedModule, BaseAssignmentsModule, BaseInquiryModule, BaseOffersModule, BaseSharedModule } from 'base';
import { BaseCustomerOffersListComponent } from './_components/list/offers-list.component';
import { BaseCustomerOffersListHeadlineComponent } from './_components/list-headline/offers-list-headline.component';
import { BaseCustomerOffersListItemComponent } from './_components/list-item/offers-list-item.component';
import { BaseCustomerOffersFiltersAndSearchComponent } from './_components/filters-and-search/offers-filters-and-search.component';
import { BaseCustomerSharedModule } from '../../shared/base-customer-shared.module';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../../../../../stazzle-medical/src/app/shared/shared.module';
import { BaseCustomerOffersGuard } from './_guards/base-customer-offers.guard';
import { BaseCustomerOfferActionButtonsComponent } from './_components/offer-action-buttons/offer-action-buttons.component';
import { BaseCustomerOfferModalComponent } from './_components/offer-modal/offer-modal.component';
import { BaseCustomerInquiryModule } from '../inquiry/inquiry.module';

@NgModule({
  declarations: [
    BaseCustomerOffersListComponent,
    BaseCustomerOffersListHeadlineComponent,
    BaseCustomerOffersListItemComponent,
    BaseCustomerOffersFiltersAndSearchComponent,
    BaseCustomerOfferActionButtonsComponent,
    BaseCustomerOfferModalComponent,
  ],
  imports: [
    CommonModule,
    AppsSharedModule,
    BaseSharedModule,
    TranslateModule,
    BaseCustomerSharedModule,
    ReactiveFormsModule,
    SharedModule,
    BaseOffersModule,
    BaseInquiryModule,
    BaseAssignmentsModule,
    BaseCustomerInquiryModule,
  ],
  exports: [BaseCustomerOffersListComponent],
  providers: [BaseCustomerOffersGuard],
})
export class BaseCustomerOffersModule {}
